var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flowplayer",attrs:{"id":_vm.id}},[_c('video',{staticStyle:{"background-color":"black"},attrs:{"controls":"","preload":"auto"}},[_c('source',{attrs:{"poster":_vm.poster,"type":"video/mp4","size":"auto"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }